import { ReduxState } from 'src/store/types';

export const pendingAutoGenerateResourceIdsSelector =
  (projectId: string) =>
  (state: ReduxState): string[] | undefined =>
    state.projects.pendingAutoGenerateResourceIdsByProjectId[projectId];

export const hasPendingAutoGenerateSelector = (state: ReduxState): boolean =>
  Boolean(
    Object.keys(state.projects.pendingAutoGenerateResourceIdsByProjectId).length
  );
